/*
This file was generated by the Surface compiler.
*/

import { MobileAccountsAgGrid } from "../hooks/mobile_accounts_ag_grid_hook"
import {
  ACCOUNT_TYPES_EVENT,
  accountTypeFilterOptions,
} from "../hooks/mobile_account_type_filter.mjs"

// The native account-type menu is offered only on the Accounts list, so only
// this grid follows it; Teams and other MobileAccountsAgGrid grids show every row.
export const AllAccounts = {
  ...MobileAccountsAgGrid,

  initGrid() {
    MobileAccountsAgGrid.initGrid.call(this)

    this.onAccountTypesChange = () => {
      this.api.updateGridOptions(
        accountTypeFilterOptions(window.__enaiaAccountTypesV1),
      )
      this.api.onFilterChanged()
    }
    this.onAccountTypesChange()
    window.addEventListener(ACCOUNT_TYPES_EVENT, this.onAccountTypesChange)
  },

  destroyed() {
    window.removeEventListener(ACCOUNT_TYPES_EVENT, this.onAccountTypesChange)
    MobileAccountsAgGrid.destroyed.call(this)
  },
}
